import React from 'react'

function ExchangeInformation() {
  return (
    <><div className="mt-[4.5rem] border-t border-gray-300"></div>
    
     <div className="mt-[4rem] flex items-center justify-center p-2 mb-[4rem]">
        <div className="max-w-3xl w-full ">
          {/* Heading - Center */}
          <h1 className="text-xl md:text-3xl letterSpacing text-center mb-12 ">
                            EXCHANGE & REFUND

          </h1>
    
            <p className="mb-6">
              <span className=" text-xl letterSpacing ">
                {" "}
                EXCHANGES
              </span><br/>
                <span className=" text-xl letterSpacing ">
                {" "}
                WITHOUT PAKISTAN
              </span>
              <br />
              <br />
              The Services may enable you to post product reviews and other
              user-generated content. If you choose to submit user generated
              content to any public area of the Services, this content will be
              public and accessible by anyone.
              <br />
              <br />
              We do not control who will have access to the information that you
              choose to make available to others, and cannot ensure that parties
              who have access to such information will respect your privacy or
              keep it secure. We are not responsible for the privacy or security
              of any information that you make publicly available, or for the
              accuracy, use or misuse of any information that you disclose or
              receive from third parties.
              <br />
              <br />
            </p>
    
    
    </div>
      </div>
    
    
    
    
    
    
    
    
    
    </>
  )
}

export default ExchangeInformation